import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

/**
 * Backwards-compat redirect.
 *
 * Phase 1.8 introduced /snapshot/:response_id as the canonical, persistent
 * snapshot view. Anyone who lands on the legacy /glimpse URL (e.g. from a
 * cached link, browser back-stack, or external share) is sent to either
 * their last submission's snapshot or back to the landing page.
 */
export default function Glimpse() {
    const navigate = useNavigate();

    useEffect(() => {
        let responseId = null;
        let shareCode = null;
        try {
            responseId = sessionStorage.getItem("klareet_last_response_id");
            shareCode = sessionStorage.getItem("klareet_last_share_code");
        } catch {
            // ignore — sessionStorage unavailable in some private modes
        }
        if (responseId && shareCode) {
            navigate(`/snapshot/${responseId}?code=${shareCode}`, {
                replace: true,
            });
        } else {
            navigate("/", { replace: true });
        }
    }, [navigate]);

    return (
        <div className="min-h-screen grid place-items-center klareet-grain klareet-glow">
            <div className="inline-block w-8 h-8 rounded-full border-2 border-klareet-bor border-t-klareet-T animate-spin" />
        </div>
    );
}
